<template>
  <div class="container">
    <div class="certificate-bg1">
    <img :src="`${ossUrl}certificate_bg1.png`"/>
    </div>
    <div class="subtitle">部分商品资质</div>
    <div class="certificate-bg2">
      <van-image lazy-load :src="`${ossUrl}certificate_bg2.png`">
        <template v-slot:loading>
          <van-loading type="spinner" size="20" />
        </template>
      </van-image>
    </div>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import configUrl from '../config/config.js';


export default {
  mixins:[configUrl],
  methods: {
    wx_jssdk() {
      this.$axios
        .post(this.getDomain() + "wx/get_signature", {
          url: window.location.href
        })
        .then(function(response) {
          if (response.data.err_code === 0) {
            wx.config({
              debug: false,
              appId: "wxe10d406d3c94eded",
              timestamp: response.data.content.timestamp,
              nonceStr: response.data.content.noncestr,
              signature: response.data.content.signature,
              jsApiList: [
                "updateAppMessageShareData",
                "updateTimelineShareData"
              ]
            });
            wx.ready(function() {
              wx.updateAppMessageShareData({
                title: "团小蜜爆款低价好物平台",
                desc:
                  "戳此链接，优选心动好货，爆款呈现！一键上架到团小蜜，转发到群马上赚钱！",
                link: "https://wxtxm.zidouchat.com/classify/#/",
                imgUrl: "http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_share_img.png",
                success: function() {
                }
              });
              wx.updateTimelineShareData({
                title: "团小蜜爆款低价好物平台",
                desc:
                  "戳此链接，优选心动好货，爆款呈现！一键上架到团小蜜，转发到群马上赚钱！",
                link: "https://wxtxm.zidouchat.com/classify/#/",
                imgUrl: "http://txm.oss-cn-beijing.aliyuncs.com/TXM_static_material_img_share_img.png",
                success: function() {
                }
              });
            });
          }
        });
    }
  },
  mounted()  {
    this.wx_jssdk();
  }
};
</script>

<style lang="scss" scoped>
.certificate-bg1 {
  width: 7.5rem;
  height: 7.04rem;
  img {
    width: 7.5rem;
    height: 7.04rem;
  }
}
.subtitle {
  text-align: center;
  font-size: 0.28rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.8);
  line-height: 0.48rem;
  padding: 0.32rem;
  background: rgba(245, 249, 251, 1);
}
.certificate-bg2 {
  width: 100%;
  height: 100%;
  text-align: center;
  padding-bottom: 0.32rem;
  background: rgba(245, 249, 251, 1);
  img {
    width: 6.86rem;
    height: 72.7rem;
  }
}
</style>
